var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("pre", { pre: true }, [
        _c("code", { attrs: { "v-pre": "", class: "language-javascript" } }, [
          _c("span", { attrs: { class: "hljs-keyword" } }, [_vm._v("this")]),
          _vm._v(".$dialog("),
          _c("span", { attrs: { class: "hljs-string" } }, [_vm._v("'base'")]),
          _vm._v(")\n")
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-421e674a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-421e674a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-markdown-loader/lib/markdown-compiler.js?raw!./src/Resource/Example/Base/Base.md
// module id = null
// module chunks = 